import { Provider } from "react-redux";
import store from "./redux/store";
import AppRoutes from "./Routes";
import "./App.module.scss";
import { useEffect } from "react";
import { isMarketPlace, isPartner, isVendor } from "./common/utility";

function App() {
  useEffect(() => {
    const body = document.querySelector("body");
    if ((isPartner() || isVendor() || isMarketPlace()) && body) {
      body.style.backgroundColor = "#fff";
      body.style.fontFamily = "Public Sans";
    } else {
      body.style.backgroundColor = "#F4F5FF";
      body.style.fontFamily = "Nunito";
    }
  }, []);
  return (
    <Provider store={store}>
      <AppRoutes />
    </Provider>
  );
}

export default App;
